import { render, staticRenderFns } from "./comprehensiveServeUser.vue?vue&type=template&id=654e00a8&scoped=true&"
import script from "./comprehensiveServeUser.vue?vue&type=script&lang=js&"
export * from "./comprehensiveServeUser.vue?vue&type=script&lang=js&"
import style0 from "./comprehensiveServeUser.vue?vue&type=style&index=0&id=654e00a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e00a8",
  null
  
)

export default component.exports